import { aspenStyles } from "@aspen/Store/Aspen/AspenStyles";
import { fancyboxStyles } from "@aspen/Store/Aspen/FancyboxStyles";
import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import { setPostStyleGuideTheme, setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import ButtonPresentationPropsDefault from "@insite/mobius/Button/presentationProps";
import { css } from "styled-components";

// For production, include a set of commonly used widgets in the main bundle
// the rest will be split into their own chunks
// Do not do this for the ./Overrides folder
const widgets = IS_PRODUCTION
    ? require.context("./Widgets", true, /(Header|Basic|Common|Footer|SignIn)\/.+?\.tsx$/)
    : require.context("./Widgets", true, /\.tsx$/);
// enable hot module reloading for widgets
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const pages = require.context("./Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id, () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
}

// const store = require.context("./Store", true);
// store.keys().forEach(key => store(key));

// Load all handlers so they are included in the bundle.
const handlers = require.context("./Handlers", true);
handlers.keys().forEach(key => handlers(key));

// in production, the widget extensions are included in the chunks created for widgets
// if (!IS_PRODUCTION) {
//     // load all widget extensions. They could be loaded individually instead
//     const widgetExtensions = require.context("./WidgetExtensions", true);
//     widgetExtensions.keys().forEach(key => widgetExtensions(key));
// }

// load all widgets. Without this they won't be included in the bundle
// const widgets = IS_PRODUCTION
//     ? require.context("./Widgets", true, /(Header|Basic|Common|Footer|SignIn)\/.+?\.tsx$/)
//     : require.context("./Widgets", true, /\.tsx$/);
// const onHotWidgetReplace = addWidgetsFromContext(widgets);
// if (module.hot) {
//     module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
// }

setPreStyleGuideTheme({
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 576, 768, 992, 1200],
        maxWidths: [540, 540, 720, 1310, 1310],
    },
    globalStyle: {
        css: css`
            /* Set the pre-style guide theme - only global styles*/
            
            html {
                -webkit-text-size-adjust: 100%;
                line-height: 1.15;
            }
            body {
                margin: 0;
            }            
            main {
                display: block;
            }
            h1 {
                font-size: 2em;
                margin: 0.67em 0;
            }
            hr {
                box-sizing: content-box;
                height: 0;
                overflow: visible;
            }
            pre {
                font-family: monospace, monospace;
                font-size: 1em;
            }
            a {
                background-color: transparent;
            }
            abbr[title] {
                border-bottom: none;
                text-decoration: underline;
                -webkit-text-decoration: underline dotted;
                text-decoration: underline dotted;
            }
            b,
            strong {
                font-weight: bolder;
            }
            code,
            kbd,
            samp {
                font-family: monospace, monospace;
                font-size: 1em;
            }
            small {
                font-size: 80%;
            }
            sub,
            sup {
                font-size: 75%;
                line-height: 0;
                position: relative;
                vertical-align: baseline;
            }
            sub {
                bottom: -0.25em;
            }
            sup {
                top: -0.5em;
            }
            img {
                border-style: none;
            }
            button,
            input,
            optgroup,
            select,
            textarea {
                font-family: inherit;
                font-size: 100%;
                line-height: 1.15;
                margin: 0;
            }
            button,
            input {
                overflow: visible;
            }
            button,
            select {
                text-transform: none;
            }
            [type="button"],
            [type="reset"],
            [type="submit"],
            button {
                -webkit-appearance: button;
            }
            button:focus {
                outline: none !important;
            }
            div:focus {
                outline: none !important;
            }
            span:focus {
                outline: none !important;
            }
            [type="button"]::-moz-focus-inner,
            [type="reset"]::-moz-focus-inner,
            [type="submit"]::-moz-focus-inner,
            button::-moz-focus-inner {
                border-style: none;
                padding: 0;
            }
            [type="button"]:-moz-focusring,
            [type="reset"]:-moz-focusring,
            [type="submit"]:-moz-focusring,
            button:-moz-focusring {
                outline: 1px dotted ButtonText;
            }
            fieldset {
                padding: 0.35em 0.75em 0.625em;
            }
            legend {
                box-sizing: border-box;
                color: inherit;
                display: table;
                max-width: 100%;
                padding: 0;
                white-space: normal;
            }
            progress {
                vertical-align: baseline;
            }
            textarea {
                overflow: auto;
            }
            [type="checkbox"],
            [type="radio"] {
                box-sizing: border-box;
                padding: 0;
            }
            [type="number"]::-webkit-inner-spin-button,
            [type="number"]::-webkit-outer-spin-button {
                height: auto;
            }
            [type="search"] {
                -webkit-appearance: textfield;
                outline-offset: -2px;
            }
            [type="search"]::-webkit-search-decoration {
                -webkit-appearance: none;
            }
            ::-webkit-file-upload-button {
                -webkit-appearance: button;
                font: inherit;
            }
            details {
                display: block;
            }
            summary {
                display: list-item;
            }
            [hidden],
            template {
                display: none;
            }

            @font-face {
                font-display: block;
                font-family: icomoon;
                font-style: normal;
                font-weight: 400;
                src: url(/UserFiles/fonts/icomoon.woff?yuzzw2) format("woff");
            }
            [class*=" icon-"],
            [class^="icon-"] {
                speak: none;
                font-feature-settings: normal;
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                font-family: icomoon !important;
                font-style: normal;
                font-variant: normal;
                font-weight: 400;
                line-height: 1;
                text-transform: none;
            }
            .icon-chevron-down:before {
                content: "\e908";
            }
            .icon-cross:before {
                content: "\e90d";
            }
            .icon-chevron-up:before {
                content: "\e911";
            }
            .icon-chevron-left:before {
                content: "\e912";
            }
            .icon-chevron-right:before {
                content: "\e913";
            }
            html {
                box-sizing: border-box;
            }
            *,
            :after,
            :before {
                box-sizing: inherit;
            }
            .visually-hidden {
                clip: rect(0, 0, 0, 0);
                border: 0;
                height: 1px;
                margin: -1px;
                overflow: hidden;
                padding: 0;
                position: absolute;
                white-space: nowrap;
                width: 1px;
            }
            .visually-hidden.focusable:active,
            .visually-hidden.focusable:focus {
                clip: auto;
                height: auto;
                margin: 0;
                overflow: visible;
                position: static;
                white-space: inherit;
                width: auto;
            }
            @font-face {
                font-display: swap;
                font-family: Inter Tight;
                font-style: normal italic;
                font-weight: 100 200 300 400 500 600 700 800 900;
                src: url(/UserFiles/intertightfonts/InterTight-VariableFont_wght.ttf) format("truetype"),
                url(/UserFiles/intertightfonts/InterTight-Italic-VariableFont_wght.ttf) format("truetype");
            }
            @font-face {
                font-display: swap;
                font-family: ITC Avant Garde Gothic;
                font-style: normal;
                font-weight: 500;
                src: url(/UserFiles/fonts/ITCAvantGardeGothic-Medium.woff2) format("woff2"),
                    url(/UserFiles/fonts/ITCAvantGardeGothic-Medium.woff) format("woff");
            }
            @font-face {
                font-display: swap;
                font-family: ITC Avant Garde Gothic;
                font-style: normal;
                font-weight: 700;
                src: url(/UserFiles/fonts/ITCAvantGardeGothic-Bold.woff2) format("woff2"),
                    url(/UserFiles/fonts/ITCAvantGardeGothic-Bold.woff) format("woff");
            }
            @font-face {
                font-display: swap;
                font-family: ITC Avant Garde Gothic CE;
                font-style: normal;
                font-weight: 400;
                src: url(/UserFiles/fonts/ITCAvantGardeGothicCEBook-Regular.woff2) format("woff2"),
                    url(/UserFiles/fonts/ITCAvantGardeGothicCEBook-Regular.woff) format("woff");
            }
            body {
                margin: 0;
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                color: #363936;
                font-family: "Inter Tight",Arial;
                font-size: 15px;
                font-weight: 500;
                letter-spacing: .01em;
                line-height: 1.4;
                background-color: #fff;
            }
            a {
                color: #253746;
                transition: color 0.35s cubic-bezier(0.3, 0.86, 0.36, 0.95);
            }
            a,
            a:hover {
                -webkit-text-decoration: none;
                text-decoration: none;
            }
            a:hover {
                color: #c8102e;
            }
            a:focus {
                outline: none !important;
            }
            dl,
            ol,
            p,
            ul {
                margin: 0 0 22px;
            }
            .as-h1,
            .as-h2,
            .as-h3,
            .as-h4,
            .as-h5,
            .as-h6,
            h1,
            h2,
            h3,
            h4,
            h5,
            h6 {
                color: #013d54;
                font-weight: inherit;
                margin: 0 0 10px;
            }
            .as-h1,
            h1 {
                font-size: 28px;
                font-weight: 500;
                letter-spacing: 0.84px;
                line-height: 1.25;
            }
            .as-h2,
            h2 {
                font-weight: 700;
                line-height: 1.26;
            }
            input[type="email"],
            input[type="search"],
            input[type="tel"],
            input[type="text"],
            textarea {
                -webkit-appearance: none;
                background-color: transparent;
                border: 1px solid;
                border-radius: 0;
                min-width: 0;
                padding: 1.2rem 2.4rem;
                transition: border-color 0.35s cubic-bezier(0.3, 0.86, 0.36, 0.95);
                width: 100%;
            }
            input[type="email"]:focus,
            input[type="email"]:hover,
            input[type="search"]:focus,
            input[type="search"]:hover,
            input[type="tel"]:focus,
            input[type="tel"]:hover,
            input[type="text"]:focus,
            input[type="text"]:hover,
            textarea:focus,
            textarea:hover {
                box-shadow: none;
                outline: none;
            }
            input[type="search"]::-webkit-search-cancel-button,
            input[type="search"]::-webkit-search-decoration,
            input[type="search"]::-webkit-search-results-button,
            input[type="search"]::-webkit-search-results-decoration {
                display: none;
            }
            td span{
                font-size:inherit !important;
            }
            /* adding aspen styles below to override any of the common stylings */
            ${aspenStyles.cssOverride.css}
            ${fancyboxStyles.cssOverride.css}
        `,
    },
    colors: {
        primary: {
            main: "#253746",
            contrast: "#FFFFFF",
        },
        secondary: {
            main: "#c8102e",
            contrast: "#FFFFFF",
        },
        text: {
            main: "#013D54",
            disabled: "#ffffff",
            accent: "#2D3435",
            link: "#c8102e",
        },
    },
    typography: {
        body: {
            size: "2.2rem",
            weight: 400,
            lineHeight: "1.5em",
            color: "#545859",
            fontFamily: "Inter Tight,Arial",
            css: css`
                backgroundColor: #fff;
                margin: 0;
                overflow-x: hidden;
                text-rendering: optimizeLegibility;
            `,
        },
        p: {
            size: "15px",
            weight: 400,
            css: css`
                margin-bottom: 1rem;
                display: block;
            `,
        },
        h1: {
            fontFamily: "Inter Tight,Arial",
            size: "2em",
            color: "#013D54",
            css: css`
                margin: 0.67em 0;
            `,
        },
        h2: {
            fontFamily: "Inter Tight,Arial",
            size: "23px",
            color: "#013D54",
            css: css`
                margin-bottom: 1rem;
                display: block;
            `,
        },
        h3: {
            fontFamily: "Inter Tight,Arial",
            size: "18px",
            color: "#363936",
        },
    },
    button: {
        primary: {
            ...ButtonPresentationPropsDefault,
            color: "primary",
            buttonType: "solid",
            css: css`
                font-color: #fff;
                font-size: 16px;
                font-family: "Inter Tight,Arial";
                &:hover {
                    
                }
            `,
        },        
    },
    footer: {
        isFullWidth: true,
        fullWidthStylingType: "solidColor",
        fullWidthColor: "#fff",
        fullWidthImage: "",
        fullWidthImageFocalPoint: "center",
    },
    header: {
        isCompactHeader: false,
        triggerPoint: 330,
        backgroundColor: "secondary.main",
        linkColor: "#fff",
        isDropShadow: false,
        dropShadowStyle: "medium",
        isBorderTop: false,
        isBorderBottom: false,
        isBorderRight: false,
        isBorderLeft: false,
        borderThickness: 0,
        borderColor: "#000",
        padding: 0,
        isBorder: false,
        isFullWidth: true,
        fullWidthStylingType: "solidColor",
        fullWidthColor: "#fff",
        fullWidthImage: "",
        fullWidthImageFocalPoint: "center",
    },
    breadcrumbs: { defaultProps: {
        css: css`
            span {
                color: #363936 !important;
                &:hover {
                    color: #363936 !important;
                }
            }
            a {
                color: #363936 !important;
                span {
                    color: #363936 !important;
                    &:hover {
                        color: #c8102e !important;
                    }
                }
            }
        `,
        typographyProps: {
            transform: "uppercase",
            weight: 500,
            lineHeight: "1.4",
            css: css`
                font-family: "Inter Tight",Arial;
                transition: color .3s ease;
                text-decoration: none;
                background-color: transparent;
                font-size: 14px;
                letter-spacing: .28px;
                list-style: none;
            `,
        }
    } },
});
